import React from 'react';

import GuideHtmlRenderer from './GuideHtmlRenderer';
import { GuideTabLayout, GuideTopic } from '../types';
import { getGuideTopicHtml } from '../utils/userGuide';

type UserGuideContentProps = {
  highlightBadge?: React.ReactNode;
  layout: GuideTabLayout;
  topic?: GuideTopic;
};

export default function UserGuideContent({
  highlightBadge,
  layout,
  topic,
}: UserGuideContentProps) {
  if (!topic) {
    return (
      <div className="guide-empty-state">
        <div className="guide-empty-card">
          <h4>{layout.emptyStateTitle}</h4>
          <p>{layout.emptyStateDescription}</p>
        </div>
      </div>
    );
  }

  const contentHtml = getGuideTopicHtml(topic);

  return (
    <div className="guide-content-scroll">
      <div className="guide-content-title-row">
        <h3 className="sr-only">{topic.title}</h3>
        {highlightBadge}
      </div>
      {contentHtml ? (
        <GuideHtmlRenderer
          className="guide-html-content guide-html-render-surface"
          html={contentHtml}
        />
      ) : (
        <div className="guide-empty-card guide-empty-card-compact">
          <h4>{topic.title || 'No content yet'}</h4>
          <p>Add HTML content for this topic from the admin page.</p>
        </div>
      )}
    </div>
  );
}
